const initialNotificationsState = {
    unreadNotifications: false,
    notificationsList: [],
    remoteNotificationsLoaded: false
}

const notificationReducer = (state = initialNotificationsState, action) => {
    switch (action.type) {
        case 'SET_REMOTE_READ':
            return Object.assign({}, state, {
                remoteNotificationsLoaded: true
            })
        case 'SET_UNREAD_NOTIFICATIONS':
            return Object.assign({}, state, {
                unreadNotifications: true
            })
        case 'SET_READ_NOTIFICATIONS':
            return Object.assign({}, state, {
                unreadNotifications: false
            })
        case 'PUSH_NOTIFICATION':
            return Object.assign({}, state, {
                notificationsList: state.notificationsList.concat(action.newNotification),
                unreadNotifications: true
            })
        case 'DISMISS_NOTIFICATION':
            const notifKey = state.notificationsList.findIndex((v,i) => v.notificationId === action.notificationId);
            let newNotifsList = state.notificationsList;
            newNotifsList[notifKey].dismissed = true;
            return Object.assign({}, state, {
                notificationsList: newNotifsList,
                unreadNotifications: true
            })
        default:
            return state
    }
}

export default notificationReducer;